// import 'bootstrap'
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/tab';

import './js/scrollDownAnimation.js';

import { initEmailLinks } from './js/email-link.js';

document.addEventListener('DOMContentLoaded', () => {
  initEmailLinks();
});

import './sass/main.scss';
import './css/iconutils.css';
import './css/fontello.css';
import './css/roboto.css';

import "./css/custom.css";
import "./css/index.css";
import "./css/partner.css";
import "./css/team.css";
import "./css/work.css";
